module.exports = __webpack_public_path__ + "img/simple-puissant.ebaa228c.svg";